var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"row",attrs:{"id":"navigation"}},[_c('div',{staticClass:"col-xs-2",on:{"click":_vm.navigationBack}},[(_vm.isCanBack)?_c('i',{staticClass:"el-icon-arrow-left"}):_vm._e()]),_c('div',{staticClass:"col-xs-8"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }